import { useSelector } from "react-redux";

const useSettings = () => {
  const { settings } = useSelector((state) => state.AppSlice);

  return { settings };
};

export default useSettings;
